import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_COPROPRIETES } from '../../../config/aides-coproprietes';

export default function CoproprieteAidesHubPage() {
  return (
    <AudienceAidesHub
      audienceId="coproprietes"
      aides={AIDES_COPROPRIETES}
      heroEyebrow="Panorama 2026 · 4 aides cumulables"
      heroHeadline="Toutes vos aides"
      heroHeadlineAccent="pour la rénovation de votre copropriété"
      heroIntro="MaPrimeRénov’ Copropriétés, CEE collectifs, éco-PTZ collectif, aides locales : quatre dispositifs cumulables conçus pour réduire la quote-part présentée à l'AG. Voici comment les combiner pour les travaux des parties communes."
      primaryCta={{ label: 'Diagnostic CEE copro en 60 sec', href: '/coproprietes/diagnostic-cee' }}
      secondaryCta={{ label: 'Préparer le vote en AG', href: '/coproprietes/process-ag' }}
      bullets={['Gratuit · sans inscription', 'Note prête pour la convocation AG', 'Aides 2026 à jour']}
      gridEyebrow="4 dispositifs cumulables"
      gridTitle="Les aides disponibles pour votre copropriété"
      ctaFinalTitle="Quelle aide pour le syndicat des copropriétaires ?"
      ctaFinalDescription="On identifie les primes CEE collectives qui s'appliquent à votre immeuble, on vérifie l'éligibilité MaPrimeRénov’ Copro, et on chiffre l'éco-PTZ collectif possible sur le reste à charge."
    />
  );
}
